import classNames from 'classnames';
import { noop } from 'shared/lib/functions';
import { Button } from 'shared/ui/Button';
import { InfoBox } from 'shared/ui/InfoBox';

interface InfoBoxReportProps {
  title: string;
  text: string;
  buttonText?: string;
  buttonOnClick?: () => void;
}

export function InfoBoxTSReport({ buttonText, buttonOnClick = noop, text, title }: InfoBoxReportProps) {
  return (
    <div className="rounded-[10px] bg-deep-blue-25 pb-2">
      <div className={classNames('px-[26px] pt-7', { 'pb-6': buttonText, 'pb-4': !buttonText })}>
        <InfoBox
          title={
            <>
              <div className="flex justify-center">
                <div className="h-[68px] w-[68px] bg-[url('/assets/progress.gif')] bg-cover bg-right" />
              </div>
              <div className="mt-[13px]">{title}</div>
            </>
          }
          text={text}
          className="bg-white !pb-8 !pt-7"
          button={buttonText ? <Button onClick={buttonOnClick}>{buttonText}</Button> : null}
        />
      </div>
    </div>
  );
}
